import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  constructor() { }

  private itemsSource: Subject<MenuItem[]> = new ReplaySubject(null);

  itemsHandler = this.itemsSource.asObservable();

  setItems(items: MenuItem[]): any {
    this.itemsSource.next(items);
  }
}
